"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordSetNewPasswordRequestPayloadToJSON = exports.ForgotPasswordSetNewPasswordRequestPayloadFromJSONTyped = exports.ForgotPasswordSetNewPasswordRequestPayloadFromJSON = void 0;
function ForgotPasswordSetNewPasswordRequestPayloadFromJSON(json) {
    return ForgotPasswordSetNewPasswordRequestPayloadFromJSONTyped(json, false);
}
exports.ForgotPasswordSetNewPasswordRequestPayloadFromJSON = ForgotPasswordSetNewPasswordRequestPayloadFromJSON;
function ForgotPasswordSetNewPasswordRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'validateLostPasswordToken': json['validateLostPasswordToken'],
        'newPassword': json['newPassword'],
    };
}
exports.ForgotPasswordSetNewPasswordRequestPayloadFromJSONTyped = ForgotPasswordSetNewPasswordRequestPayloadFromJSONTyped;
function ForgotPasswordSetNewPasswordRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'validateLostPasswordToken': value.validateLostPasswordToken,
        'newPassword': value.newPassword,
    };
}
exports.ForgotPasswordSetNewPasswordRequestPayloadToJSON = ForgotPasswordSetNewPasswordRequestPayloadToJSON;
//# sourceMappingURL=ForgotPasswordSetNewPasswordRequestPayload.js.map